var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var EyeClosed = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M11.98 3.51A6.82 6.82 0 0 0 8 2C3.58 2 0 8 0 8s1.37 2.29 3.45 4.04l.85-.85A17.76 17.76 0 0 1 1.43 8a17.67 17.67 0 0 1 1.78-2.17C4.6 4.38 6.3 3.2 8 3.2c1.06 0 2.13.47 3.12 1.17l.86-.86Zm1.15.97-.85.85A17.75 17.75 0 0 1 14.56 8a17.89 17.89 0 0 1-1.77 2.17C11.4 11.62 9.7 12.8 8 12.8c-.83 0-1.66-.28-2.45-.74l-.87.88A6.32 6.32 0 0 0 8 14c4.42 0 8-6 8-6s-1.12-1.87-2.87-3.52Z" }),
    React.createElement("path", { fill: "currentColor", d: "M6.84 10.77A3 3 0 0 0 11 8a3 3 0 0 0-.23-1.16l-.98.98.01.18a1.8 1.8 0 0 1-1.98 1.8l-.98.97ZM9 6.5A1.8 1.8 0 0 0 6.5 9l-.86.85a3 3 0 0 1 4.21-4.21L9 6.5Z" }),
    React.createElement("path", { fill: "currentColor", d: "m15.88.88-15 15L0 15 15 0l.88.88Z" }))); });
//# sourceMappingURL=EyeClosed.js.map